module.exports = __webpack_public_path__ + "static/Authorized_url-a6f073c534402c27ec339aab4a5b3ec6.png";